
<script setup lang="ts">
import { computed, toRef } from 'vue'
import type { Praeparat } from '@/types/otc/praeparat'
import {useSharedProductData} from "@/vue_components/praeparate/composables/useSharedProductData";
import {useDictionaryLabels} from "@/vue_components/praeparate/composables/useDictonaryLabels";



interface Props {
  praeparat: Praeparat
  dictionary: Record<string, string>
}

const props = defineProps<Props>()

const praeparatRef = toRef(props, 'praeparat')
const dictionaryRef = toRef(props, 'dictionary')

const { artikelList, hasMultipleArtikel, isZuzahlungsbefreit } = useSharedProductData(praeparatRef)
const { labels } = useDictionaryLabels(dictionaryRef)

</script>

<template>
  <div class="table list-artikel" :class="{ multiple: hasMultipleArtikel }">
    <table class="article-list">
      <thead>
      <tr>
        <th><span>{{ labels.menge }}</span></th>
        <th><span>{{ labels.avp }}</span></th>
        <th><span>{{ labels.pzn }}</span></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(art, index) in artikelList" :key="index">
        <td><span>{{ art.packung }}</span></td>
        <td><span>{{ art.avp }}</span></td>
        <td><span>{{ art.pzn }}</span></td>
      </tr>
      </tbody>
    </table>
  </div>

  <div v-if="isZuzahlungsbefreit" class="zuzahlungsbefreit-hint">
    <p>{{ labels.zuzahlungsbefreit }}</p>
  </div>
</template>

<style scoped>
</style>